
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clearyourdebtsfast",
      function () {
        return require("private-next-pages/clearyourdebtsfast/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clearyourdebtsfast"])
      });
    }
  